type CreateUploadFormData = { file: File; ref?: string; refId?: string; refUserId?: string | string; field?: string }

export const createUploadFormData = ({ file, ref, refId, refUserId, field }: CreateUploadFormData) => {
  const data = new FormData()

  data.append("files", file)

  if (ref && refId && field) {
    data.append("ref", ref)
    data.append("refId", String(refId))
    data.append("field", field)
    data.append("refUserId", String(refUserId))
  }

  return data
}
